import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import {FieldsetModule} from 'primeng/fieldset';
import {CalendarModule} from 'primeng/calendar';
import { FormlyFieldsetComponent } from './wrappers/formly-fieldset/formly-fieldset.component';
import { FormlyDatepickerComponent } from './types/formly-datepicker/formly-datepicker.component';
import { FormlyWrapperFormFieldComponent } from './wrappers/form-field-wrapper/form-field-wrapper.component';
import { FormlyCustomValidationMessageComponent } from '@shared/formly/formly-custom-types/formly-custom-validation-message.component';
import { DataCheckboxWrapperComponent } from './wrappers/data-checkbox-wrapper/data-checkbox-wrapper.component';
import { AddressViewModule } from '@shared/components/address-view/address-view.module';
import { TranslateModule } from '@ngx-translate/core';
import { SimpleBorderWrapperComponent } from './wrappers/simple-border-wrapper/simple-border-wrapper.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { TooltipModule } from 'primeng/tooltip';
import { FieldsetAriaFixDirective } from '@shared/directives/fieldset-area-fix.directive';
import { FixSelectButtonAriaDirective } from '@shared/directives/date-range-selectable-fix.directive';

@NgModule({
  declarations: [
    FormlyFieldsetComponent,
    FormlyDatepickerComponent,
    FormlyWrapperFormFieldComponent,
    FormlyCustomValidationMessageComponent,
    DataCheckboxWrapperComponent,
    SimpleBorderWrapperComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FieldsetModule,
    CalendarModule,
    FormlyBootstrapModule,
    FormsModule,
    FormlyModule.forChild({
      wrappers: [
        {name: 'app-formly-fieldset', component: FormlyFieldsetComponent},
        {name: 'form-field', component: FormlyWrapperFormFieldComponent},
        {name: 'data-checkbox', component: DataCheckboxWrapperComponent},
        {name: 'simple-border', component: SimpleBorderWrapperComponent}
      ],
      types: [
        {name: 'app-formly-datepicker', component: FormlyDatepickerComponent, wrappers: ['form-field']}
      ]
    }),
    AddressViewModule,
    TranslateModule,
    FontAwesomeModule,
    TooltipModule,
    FieldsetAriaFixDirective,
    FixSelectButtonAriaDirective
  ]
})
export class SharedFormlyModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faInfoCircle);
  }
}
